import axios from "axios"
import { post, del, get, put,postAttach,getImageFile } from "./api_helper"
import * as url from "./url_helper"

// Gets the logged in user data from local session
const getLoggedInUser = () => {
  const user = localStorage.getItem("user")
  if (user) return JSON.parse(user)
  return null
}

//is user is logged in
const isUserAuthenticated = () => {
  return getLoggedInUser() !== null
}

// Register Method
const postFakeRegister = (data) => post(url.POST_FAKE_REGISTER, data)

// Login Method
const postFakeLogin = data => post(url.POST_FAKE_LOGIN, data)

// postForgetPwd
const postFakeForgetPwd = data => post(url.POST_FAKE_PASSWORD_FORGET, data)

// Edit profile
const postJwtProfile = data => post(url.POST_EDIT_JWT_PROFILE, data)

const postFakeProfile = data => post(url.POST_EDIT_PROFILE, data)

//send sms verify Methods
const postSmsRegister = async (urlMan,mobileNumber)=> {
  const {mobile,countryCode} = mobileNumber;
  
  let data = JSON.stringify({
    "method": "sms",
    "smart": false,
    "mobile": mobile.toString(),
    "templateID": 8,
    "param1": "gasUnit App",
    "length": 4,
    "countryCode":parseInt(countryCode)
  });

  let config = {
    method: 'post',
    url: urlMan,
    headers: { 
      'accept-language': 'en-IR', 
      'content-type': 'application/json', 
      'apiKey': 'eb7a8cb30c3e3e427cf32ff99d8031ba'
    },
    data : data
  };
  return axios(config)
  .then(response =>{
    console.log("response send sms:",response);
    if (response) {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    }
  }).catch(err => {
   
    let message
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 404:
          message = "Sorry! the page you are looking for could not be found"
          break
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team"
          break
        case 401:
          message = "Invalid credentials"
          break
        default:
          message = err[1]
          break
      }
    }
    throw message
  })
}
//send sms verify Methods
const postAuctionResult = async (urlMan,auctionResult)=>{
  const {auctionId,userId,price} = auctionResult;
  
  let data = JSON.stringify({
    "auctionId": auctionId,
    "userId": userId,
    "price": parseInt(price),
    "templateID": 8,
    "status": 1
  });

  let config = {
    method: 'post',
    url: urlMan,
    headers: { 
      'accept-language': 'en-IR', 
      'content-type': 'application/json'
    },
    data : data
  };
  return axios(config)
  .then(response => {
    console.log("response send sms:",response);
    if (response) {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    }
  }).catch(err => {
   
    let message ='problem:CORS policy|net::ERR_FAILED'
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 404:
          message = "Sorry! the page you are looking for could not be found"
          break
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team"
          break
        case 401:
          message = "Invalid credentials"
          break
        default:
          message = err[1]
          break
      }
    }
    throw message
  })
}
//verify sms code
const postSmsToSubmit = async (urlMan,code,mobileNumber)=>{
  let data = JSON.stringify({
  
    "mobile": mobileNumber,
    "otp": code.smsNumber
  
  });

  let config = {
    method: 'post',
    url: urlMan,
    headers: { 
      'accept-language': 'en-IR', 
      'content-type': 'application/json', 
      'apiKey': 'eb7a8cb30c3e3e427cf32ff99d8031ba'
    },
    data : data
  };
  return axios(config)
  .then(response =>{
    console.log(response);
    if (response) {
      
      if (response.status >= 200 || response.status <= 299) {
  
        return response.data
      }

      throw response.data.error.message
    }
  }).catch(err => {
   
    let message
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 404:
          message = "Sorry! the page you are looking for could not be found"
          break
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team"
          break
        case 401:
          message = "Invalid credentials"
          break
        default:
          message = err[1]
          break
      }
    }
    throw message
  })
}
//Send Sms to Amir
const postSmsRegisterToAmir =  async (urlMan, dataMan)=>{
  let data = JSON.stringify({
    "method": "sms",
    "smart": false,
    "mobile": "9183805612",
    "templateID": 10,
    "param1": "Re:"+ dataMan.mobile.toString()+"@",
    "length": 4
  });

  let config = {
    method: 'post',
    url: urlMan,
    headers: { 
      'accept-language': 'fa-IR', 
      'content-type': 'application/json', 
      'apiKey': '4775409e8f08331f3a7db68261d55187'
    },
    data : data
  }
  return axios(config)
  .then(response =>{
    if (response) {
      if (response.status >= 200 || response.status <= 299) return response.data
      throw response.data
    }
  }).catch(err => {
    let message
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 404:
          message = "Sorry! the page you are looking for could not be found"
          break
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team"
          break
        case 401:
          message = "Invalid credentials"
          break
        default:
          message = err[1]
          break
      }
    }
    throw message
  })
}
// post Code Register  Method
const postCustomerRegister = data => post(url.POST_CUSTOMER_REGISTER,data)

// Identity Method
const postJwtLogin = data => post(url.POST_JWT_LOGIN, data)
const postJwtLoginByCode = data => post(url.POST_JWT_LOGIN_BY_CODE, data)
const delJwtSession = data => post(url.DELETE_JWT_SESSION,data)
export const changePasswordApi = data => post(url.CHANGE_PASSWORD_URL,data)
// postForgetPwd
const postJwtForgetPwd = data => post(url.POST_FAKE_JWT_PASSWORD_FORGET, data)

//#region Events
export const getEvents = () => get(url.GET_EVENTS)
export const addNewEvent = event => post(url.ADD_NEW_EVENT, event)
export const updateEvent = event => put(url.UPDATE_EVENT, event)
export const deleteEvent = event => del(url.DELETE_EVENT, { headers: { event } })
//#endregion
 

// get Categories
export const getCategories = () => get(url.GET_CATEGORIES)

//#region Channel 
export const getChannels = () => get(url.GET_CHANNELS)
export const getChannelById = event => get(url.GET_CHANNEL_BYID +"/"+event[0].channelId)
export const insertChannel = event => post(url.INSERT_CHANNEL,event)
export const upsertChannel = event => post(url.UPSERT_CHANNEL,event)
export const updateChannel = event => put(url.UPDATE_CHANNEL+"/"+event[0].channelId,event[1].channel)
export const updateChannelAuction = event => post(url.ADD_CHANNEL_AUCTION,event)
export const deleteChannel = id => post(url.DELETE_CHANNEL,id)
//#endregion

//#region GasProjects
export const deleteGasProjectFileApi = id => post(url.DELETE_GASPROJECT_FILE_URL,id)
export const upsertGasProject = event => post(url.UPSERT_GASPROJECT,event)
export const getGasProjects = (data) =>post(url.GET_GASPROJECTS_URL, data)
export const getGasProjectsFilterApi = (queryString) =>get(url.GET_GASPROJECTS_FILTER_URL+"?" + queryString)
export const getGasProjectsFullFilterApi = (data) =>post(url.GET_GASPROJECTS_FULL_FILTER_URL, data)
export const getGasProjectReport = (queryString) =>get(url.GET_GASPROJECT_REPORT_URL+"?" + queryString)
export const getGasProjectsEng = (queryString) =>get(url.GET_GASPROJECTS_ENG_URL+"?" + queryString)
export const postFileGasProject = (attach) => postAttach(url.POST_ADD_FILE_GASPROJECT,attach)

export const updateProcessExpertStage = (data) => postAttach(url.UPDATE_PROCESS_EXPERT_STAGE_URL,data)
export const updateProcessMapStage = (data) => postAttach(url.UPDATE_PROCESS_MAP_STAGE_URL,data)
export const updateProcessDefectStage = (data) => postAttach(url.UPDATE_PROCESS_DEFECT_STAGE_URL,data)

export const updateProcessExpertStageNew = (data) => postAttach(url.UPDATE_PROCESS_EXPERT_STAGE_NEW_URL,data)
export const updateProcessMapStageNew = (data) => postAttach(url.UPDATE_PROCESS_MAP_STAGE_NEW_URL,data)
export const updateProcessDefectStageNew = (data) => postAttach(url.UPDATE_PROCESS_DEFECT_STAGE_NEW_URL,data)

export const getGasProjectFile = (gasProjectId) => get(url.GET_GASPROJECT_FILES_URL + "?gasProjectId=" + gasProjectId)
export const getGasProjectInfoPublicApi = (gasProjectId) => post(url.GET_GASPROJECT_INFO_PUBLIC_URL + "?gasProjectId=" + gasProjectId)

export const getGasProjectFreeApi = (fileNumber) => get(url.GET_GASPROJECT_FREE_URL + "?fileNumber=" + fileNumber)
export const getPackageInstaller = () => get(url.GET_PACKAGEINSTALLER_URL)
export const sendGasProjectToGas = (fileNumber) => post(url.SEND_GASPROJECT_TOGAS_URL+"?FileNumber="+ fileNumber)
export const sendGasProjectToGasCoApi = (fileNumber) => post(url.SEND_GASPROJECT_TOGASCO_URL+"?FileNumber="+ fileNumber)
export const submitGasProjectByAdmin = model => post(url.SUBMIT_GASPROJECT_ADMIN_URL+"?Id="+ model.gasProjectId + "&ForPrepare=" + model.forPrepare)
export const addPackageInstaller = ({gasProjectId,packageInstallerId}) => post(url.ADD_PACKAGE_INSTALLER_URL+"?GasProjectId="+ gasProjectId + "&PackageInstallerId=" + packageInstallerId )
export const submitPackage = ({fileNumber,smsCode,serialNumber}) => post(url.SUBMIT_PACKAGE_URL+"?FileNumber="+ fileNumber + "&SmsCode=" + smsCode +"&SerialNumber=" + serialNumber )
export const resetPackageApi = id => post(url.RESET_PACKAGE_URL+"?GpId="+ id )
export const resolvedDefectApi = id => post(url.RESOLVED_DEFECT_URL+"?GpId="+ id )
export const prepareForMapStageApi = id => post(url.PREPARE_MAPSTAGE_URL+"?GpId="+ id )
export const prepareForFirstSupervisionStageApi = id => post(url.PREPARE_FIRSTSUPERVISION_STAGE_URL+"?GpId="+ id )
export const prepareForDesignStageApi = id => post(url.PREPARE_DESIGN_STAGE_URL+"?GpId="+ id )
export const stopGasProjectApi = data => post(url.STOP_GASPROJECT_URL,data)
export const updateGasProjectDetails = (data) => post(url.UPDATE_GASPROJECT_DETAILS_URL,data)
export const updateGasProjectCheckListApi = (data) => post(url.UPDATE_GASPROJECT_CHECKLIST_URL,data)
export const updateGasProject = (data) => post(url.UPDATE_GASPROJECT_URL,data)
export const updateGasProjectEngApi = (data) => post(url.UPDATE_GASPROJECT_ENG_URL,data)
export const deleteGasProject = id => post(url.DELETE_GASPROJECT_URL,id)
export const payByExecutorWalletApi = id => post(url.PAY_BY_EXECUTOR_WALLET_URL+"?GpId="+ id )


export const submitDesignStageApi = (data) => postAttach(url.SUBMIT_DESIGN_STAGE_URL,data)
export const submitFirstSupervisionStageApi = (data) => postAttach(url.SUBMIT_FIRSTSUPERVISION_STAGE_URL,data)

//#endregion

//#region Accounting and Transaction
export const getTransactionsApi = (data) => post(url.GET_TRANSACTION_API, data)
export const getInvoicesApi = () => get(url.GET_INVOICES_API)
export const getEngInvoicesApi = (engId) => get(url.GET_ENG_INVOICES_API +`?engId=${engId}`)
export const getEngInvoiceReportApi = ({engId,startDate,endDate}) => get(url.GET_ENG_INVOICE_REPORT_API +`?engId=${engId}&startDate=${startDate}&endDate=${endDate}`)
export const postPaymentCustom = event => post(url.POST_PAYMENT_CUSTOM_URL,event)
export const postEngPaymentCustomApi = event => post(url.POST_ENG_PAYMENT_CUSTOM_URL,event)
export const getEngWorkApi = (queryString) => get(url.GET_ENG_WORK_URL+"?" + queryString)

//#endregion

//#region gpp
export const getGppById = id => get(url.GET_GPP_BYGPID_API + "?GpId=" + id)
export const deleteProjectProcessApi = id => get(url.DEL_GPP_URL + "?GppId=" + id)
export const projectProcessApi = (data) => post(url.PROJECT_PROCESS_URL,data)
export const getListProjectProcessEngApi = (data) =>post(url.GET_LIST_PROJECT_PROCESS_ENG_URL, data)
export const getListProjectProcessReportApi = (queryString) =>get(url.GET_LIST_PROJECT_PROCESS_REPORT_URL+"?" + queryString)
export const acceptedProjectProcessApi = data => get(url.ACCEPTER_PROJECT_PROCESS_URL + "?GppId=" + data.gppId + "&Accepted=" + data.accepted)

//#endregion


//#region Users 
export const getUSERs = () => get(url.GET_USERS)
export const insertUSER = event =>  post(url.INSERT_USER,event)
export const updateUSER = event =>  post(url.UPDATE_USER,event)
export const deleteUSER = id => post(url.DELETE_USER,id)
export const getUserBalance = () => get(url.GET_USER_BALANCE)
export const getUserInfoApi = () => get(url.GET_USER_INFO_URL)
export const getUserFiles = userId => get(url.GET_USER_FILES_URL+"?UserId="+ userId)
export const postUserFile = (attach) => postAttach(url.ADD_USER_FILE_URL,attach)
export const deleteUserFile = id => post(url.DELETE_USER_FILE_URL,id)
//#endregion

//#region Executors
export const updateSignatureAttachExecutor = (attach) => postAttach(url.UPDATE_SIGNATURE_EXECUTOR,attach) 
export const sendSmsPaymentByExe = event => postAttach(url.SEND_SMS_PAYMENT_URL,event)
export const getListExecutorApi = () => get(url.GET_LIST_EXECUTOR_URL)
export const inactiveExecutorApi = data => post(url.INACTIVE_EXECUTOR_URL, data )
export const upsertExecutorApi = (data) => post(url.UPSERT_EXECUTOR_URL,data)


//#endregion

//#region Engineer
export const getListEngineerApi = () => get(url.GET_LIST_ENGINEER_URL)
export const upsertEngineerApi = (data) => post(url.UPSERT_ENGINEER_URL,data)
export const upsertEngHistoryApi = (data) => post(url.UPSERT_ENG_HISTORY_URL,data)
// If server has specific endpoints for EngLeave, map them here (fallbacks use engineer endpoints)
// EngLeave endpoints
// GET list: GET_LIST_ENG_LEAVE_URL?engId=...
export const getEngLeavesApi = () => get(url.GET_LIST_ENG_LEAVE_URL)
// Upsert EngLeave: POST body -> UpsertEngLeave endpoint
export const upsertEngLeaveApi = (data) => post(url.UPSERT_ENG_LEAVE_URL , data)
// Delete EngLeave: DELETE with query ?id=...
export const deleteEngLeaveApi = (id) => del((url.DELETE_ENG_LEAVE_URL) + `?id=${id}`)
//#endregion

//#region Common
export const getFilesCommon = (path)=> get(url.GET_FILES_COMMON_URL+`?path=upload/${path.folder}/${path.path}`)
//#endregion

//#region Qurter Tariff
export const getListQuarterTariffApi = () => get(url.GET_LIST_QUARTERTARIFF_URL)
export const upsertQuarterTariffApi = (data) => post(url.UPSERT_QUARTERTARIFF_URL, data)
export const deleteQuarterTariffApi = (id) => del(url.DELETE_QUARTERTARIFF_URL + `/${id}`)
//#endregion

//#region Payment
export const getPaymentMelliApi = amount => post(url.GET_PAYMENT_IPG_URL,amount)
export const getPaymentMelliPublicApi = values => post(url.GET_PAYMENT_IPG_PUBLIC_URL,values)

export const getPaymentIrkApi = amount => post(url.GET_PAYMENT_IRK_URL,amount)
export const getPaymentIrkPublicApi = values => post(url.GET_PAYMENT_IRK_PUBLIC_URL,values)


//#endregion


//#region Support
export const getListSupportApi = (queryString) => get(url.GET_LIST_SUPPORT_URL+"?" + queryString)
export const upsertSupportApi = (data) => postAttach(url.UPSERT_SUPPORT_URL,data)
export const getListSupportMessageApi = (queryString) => get(url.GET_LIST_SUPPORT_MESSAGE_URL+"?" + queryString)
export const upsertSupportMessageApi = (data) => post(url.UPSERT_SUPPORT_MESSAGE_URL,data)
export const closedSupportApi = id => post(url.CLOSED_SUPPORT_URL+"?SupportId="+ id)
export const switchSupportApi = (data) => post(url.SWITCH_SUPPORT_URL, data)
export const postAddSupportFileApi = (attach) => postAttach(url.POST_ADD_SUPPORT_FILE_URL,attach)
export const getSupportFilesApi = (supportId) => get(url.GET_SUPPORT_FILES_URL + "?supportId=" + supportId)
export const deleteSupportFileApi = id => post(url.DELETE_SUPPORT_FILE_URL,id)

//#endregion


//#region EngPaymentList
export const getEngPaymentListApi = (queryString) => get(url.GET_ENG_PAYMENT_LIST_URL+"?" + queryString)
export const getEngPaymentTaskApi = () => get(url.GET_ENG_PAYMENT_TASK_URL)
export const upsertEngPaymentListApi = (data) => post(url.UPSERT_ENG_PAYMENT_LIST_URL,data)
export const updateEngPaymentListApi = (data) => post(url.UPDATE_ENG_PAYMENT_LIST_URL,data)
export const engPaymentApprovedApi = (data) => post(url.ENG_PAYMENT_APPROVED_URL,data)

//#endregion

//#region FinanceReport
export const upsertFinanceReportApi = (data) => post(url.UPSERT_FINANCE_REPORT_URL,data)
export const approvedFinanceReportApi = async(queryString) => await post(url.APPROVED_FINANCE_REPORT_URL+"?" + queryString)
export const getFinanceReportDetailListApi = (queryString) => get(url.GET_FINANCE_REPORT_DETAIL_LIST_URL+"?" + queryString)
export const getFinanceReportApi = () => get(url.GET_FINANCE_REPORT_URL)
export const getServiceReportApi = (queryString) => get(url.GET_SERVICE_REPORT_URL +"?" + queryString)
export const updateFinanceReportDetailApi = (data) => post(url.UPDATE_FINANCE_REPORT_DETAIL_URL,data)

//#endregion

//#region EngQuotaBurnList
export const getEngQuotaBurnListApi = (queryString) => get(url.GET_ENG_QUOTA_BURN_URL+"?" + queryString)
export const engQuotaBurnApprovedApi = (data) => post(url.ENG_QUOTA_BURN_APPROVED_URL,data)
export const engQuotaBurnUpdateApi = (data) => post(url.ENG_QUOTA_BURN_UPDATE_URL,data)


//#endregion

//#region Client
export const getClientSettingApi = () => get(url.GET_CLIENT_SETTING_URL)
export const inactiveClientApi = (data) => post(url.INACTIVE_CLIENT_URL,data)

export const getDashboardToken = () => get(url.GET_DASHBOARD_TOKEN_URL)
export const getAdminDashboardApi = () => get(url.GET_ADMIN_DASHBOARD_URL)
export const getEngineerDashboardApi = () => get(url.GET_ENGINEER_DASHBOARD_URL)
export const getEngPaymentInvoiceApi = (engPaymentTaskId) => get(url.GET_ENG_PAYMENT_INVOICE_URL + "?engPaymentTaskId=" + engPaymentTaskId)


//export const getGasProjects = ()=>get(url.)
//#region GasProjects 

//#endregion
export {
  getLoggedInUser,
  isUserAuthenticated,
  postFakeRegister,
  postFakeLogin,
  postFakeProfile,
  postFakeForgetPwd,
  postCustomerRegister,
  postJwtLogin,
  postJwtLoginByCode,
  postJwtForgetPwd,
  delJwtSession,
  postJwtProfile,
  postSmsRegister,
  postSmsToSubmit,
  postAuctionResult,
  postSmsRegisterToAmir,
  
}
//#region PackageInstaller
export const getListPackageInstallerApi = () => get(url.GET_LIST_PACKAGEINSTALLER_URL)
export const inactivePackageInstallerApi = data => post(url.INACTIVE_PACKAGEINSTALLER_URL, data)
export const upsertPackageInstallerApi = data => post(url.UPSERT_PACKAGEINSTALLER_URL, data)
//#endregion

//#region ProjectPackages
export const getProjectPackagesApi = gasProjectId => get(`${url.GET_PROJECT_PACKAGES_URL}?gasProjectId=${gasProjectId}`)
export const getAllProjectPackagesApi = (gasProjectId) => {
  const queryParam = gasProjectId ? `?gasProjectId=${gasProjectId}` : ''
  return get(`${url.GET_ALL_PROJECT_PACKAGES_URL}${queryParam}`)
}
export const updateProjectPackageInstallerApi = data => post(url.UPDATE_PROJECT_PACKAGE_INSTALLER_URL, data)
export const updateProjectPackageSerialApi = data => post(url.UPDATE_PROJECT_PACKAGE_SERIAL_URL, data)
//#endregion

//#region Notifications
export const getNotificationsApi = () => get(url.GET_NOTIFICATIONS_URL)
export const getUnreadCountApi = () => get(url.GET_UNREAD_COUNT_URL)
export const addNotificationApi = data => post(url.ADD_NOTIFICATION_URL, data)
export const updateNotificationApi = data => post(url.UPDATE_NOTIFICATION_URL, data)
export const deleteNotificationApi = data => post(url.DELETE_NOTIFICATION_URL, data)
export const markNotificationAsSeenApi = data => post(url.MARK_NOTIFICATION_AS_SEEN_URL, data)
//#endregion

//#region Documents
export const getDocumentsApi = (entityId, entityType) => 
  get(`${url.GET_DOCUMENTS_URL}?entityId=${entityId}${entityType ? `&entityType=${entityType}` : ''}`)
export const getDocumentByIdApi = id => get(`${url.GET_DOCUMENT_BY_ID_URL}/${id}`)
export const addDocumentApi = formData => postAttach(url.ADD_DOCUMENT_URL, formData)
export const deleteDocumentApi = id => post(`${url.DELETE_DOCUMENT_URL}?id=${id}`)
export const getPhysicalFileS3Url = path => `${url.GET_PHYSICAL_FILE_S3_URL}?path=${encodeURIComponent(path)}`
//#endregion

//#region AiTraining
export const getAiTrainingApi = (activeOnly = false, category = '') => 
  get(`${url.GET_AI_TRAINING_URL}?ActiveOnly=${activeOnly}${category ? `&Category=${category}` : ''}`)
export const getAiTrainingByIdApi = id => get(`${url.GET_AI_TRAINING_BY_ID_URL}?Id=${id}`)
export const getAiTrainingCategoriesApi = () => get(url.GET_AI_TRAINING_CATEGORIES_URL)
export const upsertAiTrainingApi = data => post(url.UPSERT_AI_TRAINING_URL, data)
export const deleteAiTrainingApi = data => post(url.DELETE_AI_TRAINING_URL, data)
//#endregion

//#region AuditLogs
export const getAuditLogsByFileNumberApi = fileNumber =>
  get(`${url.GET_AUDIT_LOGS_BY_FILENUMBER_URL}?FileNumber=${fileNumber}`)
//#endregion

//#region Bank Transactions
export const getBankTransactionsApi = (queryString) => 
  get(`${url.GET_BANK_TRANSACTIONS_URL}?${queryString}`)

export const reconcileIrkTransactionsApi = (data) =>
  post(url.RECONCILE_IRK_TRANSACTIONS_URL, data)
//#endregion
